<template>
    <li class="border-gold-lighter relative border-b-2 py-5 md:pl-28">
        <div class="h2 absolute top-1/2 left-0 hidden w-24.5 -translate-y-1/2 text-center text-[#72cbcd] md:block" aria-hidden="true">{{ number }}</div>

        <div class="flex flex-col items-center gap-4 sm:flex-row">
            <div class="text-gray flex w-full grow flex-col gap-y-1 text-xs md:w-auto">
                <hgroup>
                    <p class="h7 text-primary">{{ concept.name }}</p>
                    <h2>{{ title }}</h2>
                </hgroup>
                <div class="flex flex-col gap-y-1">
                    <address class="not-italic">
                        <a :href="mapsUrl" target="_blank" rel="noopener" class="hover:text-primary transition-colors">
                            {{ address }}
                            <span class="sr-only">(opens in Google Maps)</span>
                        </a>
                    </address>
                    <p class="text-blue-dark text-base italic" v-if="food_bank">Benefiting the {{ food_bank.name }}</p>
                </div>
            </div>

            <div class="flex w-full shrink-0 gap-x-1 sm:gap-x-4 gap-y-2 sm:w-auto">
                <UiButton v-if="reservations" :href="reservationsUrl" color="turquoise" class="w-auto" :aria-label="`Reserve a table at ${title}`">Reserve a Table</UiButton>
                <UiButton :href="permalink" color="turquoise" class="w-auto" :aria-label="`View menu for ${title}`">View Menu</UiButton>
            </div>
        </div>
    </li>
</template>

<script setup>
import { computed } from 'vue';
import UiButton from '../Ui/UiButton.vue';

defineOptions({ inheritAttrs: false });

const props = defineProps({
    index: { type: Number, required: true },
    concept: { type: Object, required: true },
    title: { type: String, required: true },
    address_1: { type: String, default: null }, // eslint-disable-line
    address_2: { type: String, default: null }, // eslint-disable-line
    city: { type: String, default: null },
    state: { type: String, default: null },
    zip_code: { type: String, default: null }, // eslint-disable-line
    google_place_id: { type: String, default: null }, // eslint-disable-line
    number: { type: String, default: null },
    reservations: { type: Boolean, default: false },
    permalink: { type: String, required: true },
    spoton_id: { type: [String, Number], default: null }, // eslint-disable-line
    opentable_widget_id: { type: [String, Number], default: null }, // eslint-disable-line
    food_bank: { type: Object, required: false },
});

const address = computed(() => {
    const parts = [props.address_1, props.address_2, `${props.city}, ${props.state} ${props.zip_code}`];

    return parts.filter((p) => !!p).join(', ');
});

const mapsUrl = computed(() => {
    if (props.google_place_id) {
        return `https://www.google.com/maps/place/?q=place_id:${props.google_place_id}`;
    }

    const query = [props.concept.name, address.value];
    const queryString = encodeURI(query.filter((x) => !!x).join(' '));

    return `https://www.google.com/maps/search/?api=1&query=${queryString}`;
});

const reservationsUrl = computed(() => {
    const location = props.concept.reservationsProvider == 'opentable' ? props.opentable_widget_id : props.spoton_id;

    return `/reservations/?c=${props.concept.slug}&l=${location}`;
});
</script>
